import { useAuth0 } from "@auth0/auth0-react";
import PaymentIcon from "@material-ui/icons/Payment";
import FinanceService from "Lib/API/Finance";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";

import styled from "styled-components";
const Body = styled.div`
  width: 100%;
`;
const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #464e5f;
  text-align: center;
`;
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #f3f6f9;
  margin-top: 20px;
  padding: 30px 0;
`;
const ItemHeader = styled.div``;
const ButtonHeader = styled.div`
  border: 0;
  background: #99b7ef;
  border-radius: 3px;
  width: 146px;
  height: 43px;
  color: #f3f6f9;
  font-size: 20px;
  margin: auto;
  align-items: center;
  justify-content: center;
  display: flex;
`;
const TitleItemHeader = styled.div`
  color: #3f4255;
  font-size: 16px;
`;
const DecItemHeader = styled.div`
  color: #b5b5c3;
  font-size: 15px;
`;
const InnerBody = styled.div`
  padding: 20px 0;
`;
const TitleInnerBody = styled.div`
  color: #3f4255;
  font-size: 14px;
  font-weight: 600;
`;
const TitleCard = styled.div`
  color: black;
  font-size: 15px;
  cursor: pointer;
  width: fit-content;
`;
const ItemCardBody = styled.div`
  cursor: pointer;
  border-radius: 6px;
  background: #f3f6f9;
  padding: 20px;
  border: 1px solid black;
  width: 350px;
  height: 93px;
`;
const TitleItemCardBody = styled.div`
  font-size: 15px;
  color: #3f4255;
`;
const NumItemCardBody = styled.div`
  font-size: 15px;
  color: #2555ef;
`;
const FooterBody = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
`;
const TitleFooterBody = styled.div`
  color: #3f4255;
  font-size: 14px;
  font-weight: 600;
`;
export const SubmitButton = styled.button`
  background: #2555ef;
  border-raduis: 6px;
  height: 43px;
  width: 164px;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-inline-start: 12px;
  color: #ffffff;
  font-size: 15px;
  font-weight: bold;
  border: 0;
  &:hover {
    box-shadow: 0px 0px 5px #2555ef !important;
  }
`;

export const NoCards = () => {
  return (
    <div>
      <ItemCardBody
        style={{
          height: "100px",
          cursor: "default",
          marginTop: "10px",
          border: " 1px solid B5B5C3",
        }}
      >
        <div className="d-flex mt-5" style={{ color: "#B5B5C3" }}>
          <PaymentIcon fontSize="large" className="mx-10" />
          <h4 className="mt-1">NO CARDS</h4>
        </div>
      </ItemCardBody>
    </div>
  );
};
export const PayAll = ({
  selectionModel,
  setSelectedCard,
  data,
  cards,
  setPayAllPop,
  setPayLoading,
  ...props
}) => {
  const [cvv, setCvv] = useState("");
  const [error, setError] = useState("");
  const [selected, setSelected] = React.useState(0);
  const { getAccessTokenSilently } = useAuth0();
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  const sumCalc = (array) => {
    let sum = 0;
    for (var i = 0; i < array.length; i++) {
      sum += array[i]?.payment_amount;
    }
    return sum;
  };
  // useEffect(() => {
  //   setSelectedCard(cards[selected]?.id);
  // }, [selected]);
  const handleSubmit = async () => {
    if (cvv.length === 0) {
      setError("Required");
      return;
    }
    if (cvv.length !== 3) {
      setError("CVC is invalid");
    } else {
      setPayLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.pay(
        {
          card: cards[selected]?.id,
          requests: selectionModel,
        },
        token
      )
        .then((res) => {
          if (res) {
            props.setStatus("success");
            setPayLoading(false);
            setPayAllPop(false);
            props.setRefresh(!props.refresh);
          }
        })
        .catch((err) => {
          setPayLoading(false);
          props.setStatus("fail");
          toastr.error("Error", err?.data?.message);
        });
      props.setShowStatus(true);
      setTimeout(() => {
        props.setShowStatus(false);
      }, 2000);
    }
  };
  return (
    <Body>
      <Title>Complete Your Payment</Title>
      <Header className="row-sm-12">
        <ItemHeader className="col-sm-6">
          <TitleItemHeader>Number of Payment Requests</TitleItemHeader>
          <DecItemHeader>#{data?.length}</DecItemHeader>
        </ItemHeader>
        <ItemHeader className="col-sm-6 text-center">
          <TitleItemHeader>Total</TitleItemHeader>
          <ButtonHeader>${Math.round(sumCalc(data))}</ButtonHeader>
        </ItemHeader>
      </Header>
      <InnerBody>
        <TitleInnerBody>Choose a card</TitleInnerBody>
        <div
          className="d-flex"
          style={{ overflow: "auto", WebkitScrollSnapType: "-moz-initial" }}
        >
          {cards?.length === 0 && <NoCards />}
          {cards?.map((card, index) => {
            return (
              <div className="card-body pl-0" key={index}>
                <TitleCard
                  className="my-3"
                  style={
                    selected === index
                      ? { color: "#4caf50", cursor: "default" }
                      : {}
                  }
                  onClick={() => {
                    setSelected(index);
                  }}
                >
                  {card?.title ? card?.title : <br />}
                </TitleCard>
                <ItemCardBody
                  onClick={() => {
                    setSelected(index);
                  }}
                  style={
                    selected === index
                      ? { borderColor: "#4caf50", cursor: "default" }
                      : {}
                  }
                >
                  <TitleItemCardBody>{card?.name}</TitleItemCardBody>
                  <NumItemCardBody>
                    **** **** **** {card?.last4}
                  </NumItemCardBody>
                </ItemCardBody>
              </div>
            );
          })}
        </div>
        <FooterBody>
          <TitleFooterBody className="my-3">
            Enter the CVV code please
          </TitleFooterBody>
          CVV
          <input
            style={{
              marginLeft: "1rem",
              borderRadius: "6px",
              border: "none",
              height: "45px",
              background: "#f3f6f9",
            }}
            id="cvv_code"
            name="cvv_code"
            type="number"
            onKeyDown={(e) => preventArrows(e)}
            placeholder=""
            onChange={(event) => {
              if (event.target.value.length < 4) {
                if (error) setError("");
                setCvv(event.target.value.match(regex)[0]);
              }
            }}
            value={cvv}
            required
          />
        </FooterBody>
        <div style={{ color: "red", fontSize: "12px" }}>{error}</div>
      </InnerBody>
      <SubmitButton
        className="mx-auto"
        onClick={cards?.length !== 0 ? handleSubmit : {}}
        style={
          cards?.length === 0
            ? { background: "#99b7ef", cursor: "default" }
            : {}
        }
      >
        Pay
      </SubmitButton>
    </Body>
  );
};
